import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-common-offer',
  templateUrl: './common-offer.component.html',
  styleUrls: ['./common-offer.component.scss']
})
export class CommonOfferComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
